export default __webpack_public_path__ + "static/media/courses.e7bd318b.svg";